import { Maybe } from 'types/FMSGraphqlTypes'
import { TFreightCapabilities } from '../types'

export const getFreightCapabilitiesLabels = (
  freightCapabilities: Maybe<TFreightCapabilities>
): string => {
  const { isDrayageCapable, isFtlCapable, isIntermodalCapable, isLtlCapable } =
    freightCapabilities || {}
  const labels = [
    ...(isIntermodalCapable ? ['Intermodal'] : []),
    ...(isFtlCapable ? ['FTL'] : []),
    ...(isLtlCapable ? ['LTL'] : []),
    ...(isDrayageCapable ? ['Drayage'] : []),
  ]
  return labels.join(', ')
}
